import Swal from 'sweetalert2'
import inMemoryJWT from "../../auth/inMemoryJwt";
import { urlServer } from "../../config/GlobalConstant";

import {
    CREATE_WINERY,
    IS_LOADING_WINERIES,
    DELETE_WINERY,
    EDIT_WINERY,
    LIST_OF_WINERIES,
    IS_LOADING_DELETE_WINERIES,
    GET_ONLY_ONE_WINERY,
    IS_LOADING_ONLY_WINERY,
    IS_LOADING_UPDATE_WINERIES
} from './types'

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2000,

})

export const seeWineries = (codeName="") => async dispatch => {
    dispatch({ //Esto se lo envía a combineReducer, el que está en el index
        type: IS_LOADING_WINERIES
    });
    await fetch(`${urlServer}wineries/search-wineries-by-name-or-code`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, body:JSON.stringify({
            textString:codeName
        })
    })
        .then(response => response.json())
        .then(respJson => {
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: LIST_OF_WINERIES,
                payload: respJson.data
            });

        })
        .catch(error => {
            console.log()
        })

}


export const createWinery = ({ Nwinery, Cwinery, Dwinery }) => async dispatch => {
    dispatch({
        type: IS_LOADING_WINERIES
    });
    await fetch(`${urlServer}wineries/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            name: Nwinery,
            ubication: { city: Cwinery, state: Dwinery }
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: CREATE_WINERY
            });
            if (respJson.success === true) {
                Toast.fire({
                    icon: 'success',
                    title: 'Bodega Creada Correctamente'
                })
            } else {
                if (respJson.error.code === 11000) {
                    Toast.fire({
                        icon: 'error',
                        title: 'Ya Exite Una Bodega Con Ese Nombre'
                    })
                } else {
                    Toast.fire({
                        icon: 'error',
                        title: 'Error al Crear'
                    })
                }
            }
        })
        .catch(error => {
            console.log()

        })
}
export const deleteWinery = (id) => async dispatch => {
    dispatch({
        type: IS_LOADING_DELETE_WINERIES
    });
    await fetch(`${urlServer}wineries/delete`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify({
                wineryId : id
            })
        })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: DELETE_WINERY,
                payload:{id}
            });
            if (respJson.success === true){
                Toast.fire({
                    icon: 'success',
                    title: 'Bodega Eliminada Correctamente'
                })
            }else{
                    Toast.fire({
                        icon: 'error',
                        title: 'Error al Eliminar'
                    })
                }
        })
        .catch(error => {
            console.log()
        })
}

export const updateWinery = (values,id) => async dispatch => {
    dispatch({
        type: IS_LOADING_UPDATE_WINERIES
    });
    await fetch(`${urlServer}wineries/update`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify({
                wineryId : id,
                name : values.Nwinery,
                ubication : {city : values.Cwinery, state : values.Dwinery}
            })
        })
        .then(response => response.json())
        .then(respJson => {
            dispatch({
                type: EDIT_WINERY,
                payload:{data:respJson.data}
            });
            if (respJson.success === true){
                Toast.fire({
                    icon: 'success',
                    title: 'Bodega Actualizada Correctamente'
                })
            }else{
                    Toast.fire({
                        icon: 'error',
                        title: 'Error al Actualizar'
                    })
                }
        })
        .catch(error => {
            console.log()
        })
}
export const getOneWineryById = (id) => async dispatch => {
    dispatch({
        type: IS_LOADING_ONLY_WINERY
    });
    await fetch(`${urlServer}wineries/get-one-by-id`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify({
                wineryId : id
            })
        })
        .then(response => response.json())
        .then(respJson => {
            dispatch({
                type: GET_ONLY_ONE_WINERY,
                payload:{data:respJson.data}
            });
        })
        .catch(error => {
            console.log()
        })
}